"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./utils/log"));
__export(require("./utils/resolveFunction"));
__export(require("./utils/CompositeKeyWeakMap"));
__export(require("./utils/returnAtIndex"));
__export(require("./utils/copyMetaData"));
__export(require("./utils/bind"));
__export(require("./utils/wrapConstructor"));
__export(require("./utils/assignAll"));
__export(require("./utils/isDecoratorArgs"));
__export(require("./utils/isPrototypeAccess"));
//# sourceMappingURL=utils.js.map